export default function(amount, currency = 'AUD', locale = 'en-AU') {
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
  });
  return formatter.format(amount);
}